import { useCallback } from 'react';

import { paramToString } from './components/TaskFields/utils';
import {
  selectDriverArgumentsByTaskProperties,
  selectParameterDefinitions,
} from '../../features/workflow/selectors';
import { useAppSelector } from '../../hooks';
import {
  CodeTaskProperties,
  DataExportTaskProperties,
  PropertiesType,
  TaskParameterValue,
  TaskProperties,
} from '../../types';

export const useFieldData = (
  taskProperties: TaskProperties | CodeTaskProperties | DataExportTaskProperties
) => {
  const driverArguments = useAppSelector(
    selectDriverArgumentsByTaskProperties(
      taskProperties.propertiesType !== PropertiesType.Code &&
        taskProperties.propertiesType !== PropertiesType.DataExport
        ? taskProperties
        : null
    )
  );
  const parameterDefinitions = useAppSelector(selectParameterDefinitions);

  const getFieldData = useCallback(
    (fieldName: string) => {
      const parameter = driverArguments?.[fieldName];
      const formattedDefaultValue = paramToString(
        parameter?.default as TaskParameterValue
      );
      const value = paramToString(
        taskProperties.taskParameters?.[fieldName] ?? formattedDefaultValue
      );
      const parameterAppliedReferenceId =
        taskProperties.taskAppliedParameters?.[fieldName];
      const parameterReference = parameterDefinitions.find(
        (p) => p.id === parameterAppliedReferenceId
      );
      const parameterAppliedValue = parameterReference
        ? String(parameterReference.default ?? '')
        : value;

      return {
        parameter,
        parameterAppliedReferenceId,
        parameterReference,
        parameterAppliedValue,
      };
    },
    [driverArguments, parameterDefinitions, taskProperties]
  );

  return { getFieldData };
};
